import React from "react";
import Layout from "./Layout";
import { MediaModel } from "../models";
import Header from "./Header";
import { MediaItem, MediaType } from "@mindmemobile/mm-shared-library";
import MediaBoxes from "./MediaBoxes";
import { toJS } from "mobx";
import { MediaTypes } from "../enums";
import { observer } from "mobx-react";
import { ModalComponent } from "@mindmemobile/mm-shared-global";

type IProps = {
  hideLabel?: boolean;
  allowedMediaTypes?: (keyof typeof MediaType)[];
  medias?: MediaModel[];
  onUpload: (medias: MediaModel[]) => void;
  onDelete: (media: MediaModel) => void;
  multiple: boolean;
  onSelectLibraryMedia: (media: MediaItem) => void;
  onFavourite?: (media: MediaModel) => void;
  showUploadButtons?: boolean;
  hideOverlays?: boolean;
  allowOnlyOne?: boolean;
  toggleLibrary: (show: boolean, fromUpload?: boolean) => void;
  showLibrary: boolean;
  updateMedia: (medias: MediaModel[]) => void;
  showUpload?: boolean;
  key?: string;
};

const FullLibraryViewInPopUp: React.FC<IProps> = (props) => {
  return (
    <ModalComponent
      title="Upload Media"
      titleFontSize="22px"
      showFooter={false}
      minHeight="440px"
      bodyBackgroundColor="#fefefe"
      footerBackground="#F4F7FB"
      footerHeight="auto"
      onClose={() => props.toggleLibrary(false)}
      footerContent={null}
      // wrapperWidth="calc(100% - 100px)" //unsplash and pixabay needs atleast this to get 5 in a row
      wrapperWidth="1150px"
      maxHeight="144px"
    >
      <MediaBoxes
        key={props.key || "medias"}
        multiple={props.multiple}
        hideLabel={props.hideLabel}
        hideOverlays={props.hideOverlays}
        allowOnlyOne={props.allowOnlyOne}
        medias={toJS(props.medias || [])}
        onUpload={(medias: MediaModel[]) => props.updateMedia(medias)}
        onDelete={(media: MediaModel) => props.onDelete(media)}
        onSelectLibraryMedia={(media) => props.onSelectLibraryMedia(media)}
        onFavourite={(media: MediaModel) =>
          props.onFavourite && props.onFavourite(media)
        }
        allowedMediaTypes={props.allowedMediaTypes}
        toggleLibrary={(show: boolean, fromUpload?: boolean) =>
          props.toggleLibrary(show, fromUpload)
        }
        showLibrary={props.showLibrary}
        showUpload={props.showUpload}
        className="media-box-popup"
      />
    </ModalComponent>
  );
};

export default observer(FullLibraryViewInPopUp);
